// extracted by mini-css-extract-plugin
export default {"avatar":"Avatar_avatar__pDF+e","sm":"Avatar_sm__6TMZv","md":"Avatar_md__qONHe","lg":"Avatar_lg__T2uQr","img":"Avatar_img__7MQdh","initials":"Avatar_initials__s2mUx"};